import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_up",
  "use": "icon-arrow_up-usage",
  "viewBox": "0 0 8.6 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8.6 14\" id=\"icon-arrow_up\">\n<polygon points=\"4.3,0 0,6.5 3.8,6.5 3.8,14 4.8,14 4.8,6.5 8.6,6.5 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol